/** Represents the prefix for the command pubSub event names. */
export const commandPubSubEventNamePrefix = 'command:';
/** Represents the delimiter between group and command name. */
export const commandGroupDelimiter = ':';
/** Represents the internal command groups. */
export const commandGroups = [
    'app',
    'conversation',
    'search',
    'richTextEditor',
];
/** Represents the attributes of the command groups. */
export const commandGroupAttributes = {
    app: {
        label: 'Global commands',
    },
    conversation: {
        label: 'Conversation',
    },
    search: {
        label: 'Search',
    },
    richTextEditor: {
        label: 'Text editor',
    },
};
